import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Link,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText,
    Checkbox,
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as Dropdown } from "../../../../assets/images/dropdown.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import adminService from "../../../../services/admin.service";
import ClickAwayListener from '@mui/material/ClickAwayListener';

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
};

const GoalProgressEdit = (props) => {
    const { t } = useTranslation();

    useEffect(() => {
    }, []);

    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            }
        },

        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },
        disabled: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            }
        },

    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false });
    }
    const classes = useStyles();
    let { groupID, serial } = useParams()

    const [List, setList] = React.useState({
        config: [
            {
                color: "#BF9257",
            },
            {
                color: "#C1774E",
            },
            {
                color: "#4B8178",
            },
            {
                color: "#5D9ABE",
            },
            {
                color: "#336AA1",
            },
            {
                color: "#6A5A93",
            },
            {
                color: "#9C5684",
            },
            {
                color: "#984343",
            },
            {
                color: "#EFB76D",
            },
            {
                color: "#F19562",
            },
            {
                color: "#5DA196",
            },
            {
                color: "#74C1ED",
            },
            {
                color: "#4085C9",
            },
            {
                color: "#8470B8",
            },
            {
                color: "#C36BA5",
            },
            {
                color: "#BE5454",
            },
            {
                color: "#F7DBB6",
            },
            {
                color: "#F8CAB1",
            },
            {
                color: "#AED0CA",
            },
            {
                color: "#BAE0F6",
            },
            {
                color: "#9FC2E4",
            },
            {
                color: "#D8D3E9",
            },
            {
                color: "#E1B5D2",
            },
            {
                color: "#DFA9A9",
            },
            {
                color: "#FDF8F0",
            },
            {
                color: "#FEF4EF",
            },
            {
                color: "#EFF6F4",
            },
            {
                color: "#F1F9FD",
            },
            {
                color: "#ECF3FA",
            },
            {
                color: "#F3F1F8",
            },
            {
                color: "#F9F0F6",
            },
            {
                color: "#F9EEEE",
            },
        ]
    });
    const [status, setStatus] = React.useState(true);
    const [iconIcon, setIconIcon] = React.useState("");
    const [btnIcon, setBtnIcon] = React.useState("");
    const [colorIcon, setColorIcon] = React.useState("");
    const [openIcon, setOpenIcon] = React.useState(false);
    const [fontColorStatus, setFontColorStatus] = React.useState(false);
    const [backgroundColorStatus, setBackgroundColorStatus] = React.useState(false);
    const [edit, setEdit] = React.useState(false);
    const [adjust, setAdjust] = React.useState(true);
    const [name, setName] = React.useState("");
    const [types, setTypes] = React.useState("");
    const anchorRef = React.useRef(null);
    const handleStatus = () => {
        setStatus(!status)
    }

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));
    const validationSchema = yup.object({
        groupEN: yup.string().required(t('admin.inputForm.msgError.code')),
        nameEN: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        description_en: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        // nameTH: yup.string().max(255).required(t('admin.inputForm.msgError.nameTH')),
        fontColor: yup.string().required(t('admin.inputForm.msgError.fontColor')),
        backgroundColor: yup.string().required(t('admin.inputForm.msgError.backgroundColor')),

    });
    const formik = useFormik({
        initialValues: {
            groupEN: '',
            nameEN: '',
            nameTH: '',
            fontColor: "#5DA196",
            backgroundColor: "#5DA1961A",
            makeDefault: false,
            description_th: '',
            description_en: ''
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            submit(values)
            // openSuccessAddDialog(true)
        },
    });
    useEffect(() => {
        if (edit === false) {
            setEdit(true)
        }
    }, [formik.values]);
    const onOpenIcon = (color, btn, icon) => {
        setOpenIcon(true)
        // setIconIcon(icon)
        // setBtnIcon(btn)
        // setColorIcon(color['background-color'])
    }
    const onCloseIcon = () => {
        setOpenIcon(false)
        // setIconIcon("")
        // setBtnIcon("")
        // setColorIcon("")
    }
    const onSelectIcon = (data) => {
        // setIconIcon(data);
        formik.setFieldValue("icon", data)
    }
    const handleSubmit = () => {
        formik.submitForm()
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }
    const onOpenbackgroundColor = () => {
        setBackgroundColorStatus(!backgroundColorStatus)
        setFontColorStatus(false)
    }
    const onOpenColor = () => {
        if (adjust === true) {
            setFontColorStatus(!fontColorStatus)
            setBackgroundColorStatus(false)
        }
    }
    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        openDialog(false);
        navigate('/admin/goal-progress/' + groupID, { replace: false });

    };
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [isAddDialogOpen, openDialog] = React.useState(false);
    const handleOpenDialog = (value) => {
        openDialog(true);
    };
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/goal-progress/' + groupID, { replace: false });
    }
    useEffect(() => {
        adminService.detailGoalProgress(serial).then(
            (response) => {
                let data = response?.data?.goal_progress_data
                setName(response?.data?.goal_progress_group?.name)
                // setAdjust(response?.data?.cycle?.options?.allow_adjust === true ? true : false)
                formik.setFieldValue("groupEN", response?.data?.goal_progress_group?.name)
                formik.setFieldValue("nameEN", data?.options?.name_en !== undefined ? data?.options?.name_en : data?.name)
                formik.setFieldValue("nameTH", data?.options?.name_th !== undefined ? data?.options?.name_th : "")
                formik.setFieldValue("fontColor", data?.color?.font)
                formik.setFieldValue("description_en", data?.options?.description_en !== undefined ? data?.options?.description_en : data?.description)
                formik.setFieldValue("description_th", data?.options?.description_th !== undefined ? data?.options?.description_th : "")
                formik.setFieldValue("backgroundColor", data?.color?.background)
                formik.setFieldValue("makeDefault", data?.is_default)
                setEdit(false)
                setTypes(data?.type)
            },
        ).catch(() => {
        })
    }, []);
    const submit = (data) => {
        adminService.editGoalsProgress({
            name_en: data.nameEN,
            name_th: data.nameTH,
            font_color: data.fontColor,
            description_en: data.description_en,
            description_th: data.description_th,
            background_color: data.backgroundColor,
            options: {
                goal_progress_group_id: groupID
            },
            is_default: data.makeDefault
        }, serial).then(
            (response) => {
                openSuccessAddDialog(true)
            },
        ).catch(() => {
            handleOpenFailedMessageDialog()
        })
    }
    const handleCheckMakeDefault = () => {
        formik.setFieldValue("makeDefault", !formik.values.makeDefault)
    };
    const setColor = (data) => {
        formik.setFieldValue("fontColor", data)
        formik.setFieldValue("backgroundColor", data + "1a")
    }
    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setFontColorStatus(false);
    };
    return (
        <>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A"><span style={styles.link} onClick={() => clickLink('/admin/goal-component')}>{t('admin.label.goalComponent')}</span> / <span style={styles.end} >{t('admin.label.goalProgressGroup')}</span> / <span style={styles.link} onClick={() => clickLink('/admin/goal-progress/' + groupID)} >{name}</span> / <span style={styles.end} >{t('admin.label.editGoalProgressItem')}</span></Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {t('admin.label.editGoalProgressItem')}
                            </Typography>
                        </Grid>
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">

                            <Grid container item>
                                <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%' }} classes={{ root: classes.error }}>

                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "50px 0px 20px 25px" }}>
                                        <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.groupEN')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.groupEN && formik.errors.groupEN)}
                                                fullWidth
                                                helperText={formik.touched.groupEN && formik.errors.groupEN}
                                                margin="normal"
                                                name="groupEN"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={name}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.groupEN')}
                                                classes={{ root: classes.disabled }}
                                                disabled
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.nameEN')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.nameEN && formik.errors.nameEN)}
                                                fullWidth
                                                helperText={formik.touched.nameEN && formik.errors.nameEN}
                                                margin="normal"
                                                name="nameEN"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameEN}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.nameEN')}
                                                classes={{ root: adjust === true ? classes.input : classes.disabled }}
                                                disabled={adjust === true ? false : true}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.nameTH')}</Typography>
                                            <TextField
                                                // error={Boolean(touched.nameTH && errors.nameTH)}
                                                fullWidth
                                                // helperText={touched.nameTH && errors.nameTH}
                                                margin="normal"
                                                name="nameTH"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.nameTH}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.nameTH')}
                                                classes={{ root: adjust === true ? classes.input : classes.disabled }}
                                                disabled={adjust === true ? false : true}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.description')} (EN) <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                            <TextField
                                                error={Boolean(formik.touched.description_en && formik.errors.description_en)}
                                                fullWidth
                                                helperText={formik.touched.description_en && formik.errors.description_en}
                                                margin="normal"
                                                name="description_en"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.description_en}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.description')}
                                                classes={{ root: adjust === true ? classes.input : classes.disabled }}
                                                disabled={adjust === true ? false : true}
                                            />
                                        </Grid>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.description')} (TH)</Typography>
                                            <TextField
                                                // error={Boolean(formik.touched.description && formik.errors.description)}
                                                fullWidth
                                                // helperText={formik.touched.description && formik.errors.description}
                                                margin="normal"
                                                name="description_th"
                                                onBlur={formik.handleBlur}
                                                onChange={formik.handleChange}
                                                type="text"
                                                value={formik.values.description_th}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                placeholder={t('admin.inputForm.placeholder.description')}
                                                classes={{ root: adjust === true ? classes.input : classes.disabled }}
                                                disabled={adjust === true ? false : true}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg={6} md={6} xs={6} display="flex" sx={{ paddingTop: "0 !important" }}>
                                            {types !== "not_started" ?
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <Box>
                                                        <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.fontColor')}<Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                        <Box sx={{
                                                            position: "relative",
                                                            marginTop: "16px",
                                                            ".MuiFormControl-root": {
                                                                marginTop: "0"
                                                            }
                                                        }}>
                                                            <Box py="5px" pl="7px" sx={{ display: "flex", position: "relative", cursor: "pointer", "align-items": "center", width: "130px", height: "40px", border: "1px solid #CED4DA", "box-sizing": "border-box", "border-radius": "4px" }} onClick={onOpenColor}>
                                                                <Box sx={{ "background-color": formik.values.fontColor, height: "28px", width: "85px", "border-radius": "3px" }} mr="15px"></Box>
                                                                {adjust === true ? <Dropdown style={{ color: "#404349", fontSize: "16px", fontWeight: "300" }} ></Dropdown> : null}
                                                            </Box>
                                                            <Box sx={{ position: "absolute", "z-index": "9", }}>
                                                                <Box sx={{ "box-shadow": "0px 4px 10px rgb(0 0 0 / 10%)", "border-radius": "10px", overflow: "hidden", transition: "all .8s", "max-height": fontColorStatus ? "999px" : "0px", width: "max-content" }}>
                                                                    <Box sx={{ width: "100%", "max-width": "540px", background: "white", "min-height": "400px", "padding": "30px 30px 44px", }}>
                                                                        <Typography fontSize={24} lineHeight="26.4px" color="#404349" fontWeight="500" pb="20px">Color</Typography>
                                                                        <Divider />
                                                                        <Box pt="20px" pb="25px" sx={{ ".MuiFormControl-root": { "margin-bottom": "0px" }, display: "flex", "align-items": "center", "margin": "0 -25px" }}>
                                                                            <Box sx={{ display: "flex", "align-items": "center", margin: "0 25px", width: "50%" }}>
                                                                                <Typography fontSize={16} lineHeight="24px" color="#404349" fontWeight="400" pr="30px">HEX</Typography>
                                                                                <TextField
                                                                                    error={Boolean(formik.touched.fontColor && formik.errors.fontColor)}
                                                                                    helperText={formik.touched.fontColor && formik.errors.fontColor}
                                                                                    margin="normal"
                                                                                    name="fontColor"
                                                                                    // onBlur={handleBlur}
                                                                                    onChange={e => setColor(e.target.value)}
                                                                                    type="text"
                                                                                    value={formik.values.fontColor}
                                                                                    variant="outlined"
                                                                                    InputLabelProps={{
                                                                                        shrink: true,
                                                                                    }}
                                                                                    placeholder={t('admin.inputForm.placeholder.fontColor')}
                                                                                    classes={{ root: classes.input }}
                                                                                // size="small"
                                                                                />
                                                                            </Box>
                                                                            <Box sx={{ display: "flex", "align-items": "center", margin: "0 25px", width: "50%" }}>
                                                                                <Typography fontSize={16} lineHeight="24px" color="#404349" fontWeight="400" pr="30px">HEX</Typography>
                                                                                <Box sx={{ width: "100%", height: "41px", background: formik.values.fontColor, "border-radius": "4px" }} ></Box>
                                                                            </Box>
                                                                        </Box>
                                                                        <Typography fontSize={16} lineHeight="24px" pb="10px" color="#404349" fontWeight="400">Template Colors</Typography>
                                                                        <Box sx={{ margin: "-10px -10px", display: "flex", "flex-flow": "row wrap" }}>
                                                                            {List.config.length > 0 ?
                                                                                List.config.map(item => (
                                                                                    <Box onClick={e => setColor(item.color)} sx={{ cursor: "pointer", backgroundColor: item.color, width: "40px", height: "40px", "border-radius": "3px", margin: "10px 11.25px" }}></Box>
                                                                                ))
                                                                                : null
                                                                            }
                                                                        </Box>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                </ClickAwayListener>
                                                : null
                                            }
                                            <Box sx={{ paddingLeft: types !== "not_started" ? "80px" : "0px" }}>
                                                <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.inputForm.makeDefault')}</Typography>
                                                <Grid item display="flex" alignItems="center" mt={2}>
                                                    <Checkbox disabled={adjust === true ? false : true} color="primary" sx={{ pl: 0 }} checked={formik.values.makeDefault} onChange={handleCheckMakeDefault} />
                                                </Grid>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "40px 0px 20px 25px" }}>
                                        <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", position: "relative" }}>
                                            <Divider></Divider>
                                        </Grid>
                                    </Grid>
                                    <Grid container lg md xs={12} display="flex" spacing={4} sx={{ padding: "30px 0px 20px 25px" }}>
                                        <Grid item lg={4} md={4} xs={4} sx={{ paddingTop: "0 !important", position: "relative" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.label.previewEN')}</Typography>
                                            {formik.values.nameEN !== "" ?
                                                <Box sx={{ backgroundColor: formik.values.backgroundColor, padding: "8px 20px", width: "max-content", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "30px", border: types === "not_started" ? "1px solid #DADADA" : "none" }}>
                                                    <Typography fontSize={16} lineHeight="24px" sx={{ color: formik.values.fontColor }}>{formik.values.nameEN}</Typography>
                                                </Box>
                                                :
                                                <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">-</Typography>
                                            }
                                        </Grid>
                                        <Grid item lg={4} md={4} xs={4} sx={{ paddingTop: "0 !important", position: "relative" }}>
                                            <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">{t('admin.label.previewTH')}</Typography>
                                            {formik.values.nameTH !== "" ?
                                                <Box sx={{ backgroundColor: formik.values.backgroundColor, padding: "8px 20px", width: "max-content", borderRadius: "5px", display: "flex", justifyContent: "center", alignItems: "center", marginTop: "30px", border: types === "not_started" ? "1px solid #DADADA" : "none" }}>
                                                    <Typography fontSize={16} lineHeight="24px" sx={{ color: formik.values.fontColor }}>{formik.values.nameTH}</Typography>
                                                </Box>
                                                :
                                                <Typography variant="subtitle1" fontSize={18} lineHeight="24px" display="flex">-</Typography>
                                            }
                                        </Grid>
                                    </Grid>
                                    <Grid container mt={3} mb={3} pr={4} >
                                        <Grid item xs display="flex" flexDirection="row-reverse">
                                            <Box sx={{ width: "100px" }}>
                                                <Button disabled={adjust === true ? edit === true ? false : true : true} onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                                    {t('label.save')}
                                                </Button>
                                            </Box>
                                            <Box mr={2} sx={{ width: "100px" }}>
                                                <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                                    {t('label.cancel')}
                                                </Button>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t('admin.label.GoalProgressEditSuccessfully')}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={t(`admin.label.GoalProgressEditFail`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                </Container>
            </Box >
        </>
    )
};
export default GoalProgressEdit;
